import Immutable from 'immutable';

const SkillResultRecord = Immutable.Record({
  skillId: undefined,
  name: undefined,
  score: undefined,
  layeredScore: undefined,
  layeredFullMark: undefined,
});

export default class SkillResult extends SkillResultRecord { }



// WEBPACK FOOTER //
// ./data/IndividualDevelopmentPlans/SkillResult/model.js